<template>
  <div class="orders">
    <div class="orderMain">
      <div class="infosearch">
        <span class="labelTit">日期范围</span>
        <el-date-picker
          v-model="orderTime"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format='yyyy-MM-dd'
          :default-time="['00:00:00', '23:59:59']"
          style="width: 260px;margin-right: 10px"
        ></el-date-picker>
        <span class="labelTit">员工姓名</span>
        <el-select v-model="keyName" placeholder="请选择员工" @change="acountOne" style="width:150px;margin-right: 10px">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="(i,index) in staffSList" :key="'staffList-'+index" :label="i.staffName" :value='i.staffId'></el-option>
        </el-select>
        <el-button
          class="searchBtn"
          @click="search(1)"
          v-loading.fullscreen.lock="fullscreenLoading"
        ></el-button>
        <!-- <el-button class="darkBtn" @click="outportExcel">导出</el-button> -->
      </div>
      <div class="redAcount">现金流总收支（销售现金流+充值现金流） 单位：元</div>
      <el-table :data="tableData" show-summary class="myMemTable" :header-cell-style="{background:'#EFF1F5'}" style="width: 100%" max-height="340">
        <el-table-column align="center" prop="cashierName" label="收银员名称/销售人员名称"></el-table-column>
        <el-table-column align="center" prop="cash" label="现金"></el-table-column>
        <el-table-column align="center" prop="bankMoney" label="银行卡"></el-table-column>
        <el-table-column align="center" prop="aliPayMoney" label="支付宝"></el-table-column>
        <el-table-column align="center" prop="wechatMpney" label="微信"></el-table-column>
        <el-table-column align="center" prop="totalMoney" label="现金流合计"></el-table-column>
      </el-table>
      <div class="redAcount">销售收支（现金流+会员账户） 单位：元</div>
      <el-table :data="tableData2" :summary-method="getSummaries" show-summary class="myMemTable" :header-cell-style="{background:'#EFF1F5'}" style="width: 100%" max-height="340">
        <el-table-column align="center" prop="cashierName" label="销售人员名称" width="106px"></el-table-column>
        <el-table-column align="center" prop="cash" label="现金"></el-table-column>
        <el-table-column align="center" prop="bankMoney" label="银行卡"></el-table-column>
        <el-table-column align="center" prop="alipayMoney" label="支付宝"></el-table-column>
        <el-table-column align="center" prop="wechatpayMoney" label="微信"></el-table-column>
        <el-table-column align="center" prop="rechargeAccountMoney" label="充值账户消耗" width="105px">
          <template slot-scope="scope">
            <span :class="{'red': scope.row.rechargeAccountMoney && scope.row.rechargeAccountMoney !=0}">{{scope.row.rechargeAccountMoney == 0 ? 0 : ('-' + scope.row.rechargeAccountMoney)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="giftAccountMoney" label="赠送账户消耗" width="105px">
          <template slot-scope="scope">
            <span :class="{'red': scope.row.giftAccountMoney && scope.row.giftAccountMoney !=0}">{{scope.row.giftAccountMoney == 0 ? 0 : ('-' + scope.row.giftAccountMoney)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="returnMoney" label="返现账户消耗" width="105px">
          <template slot-scope="scope">
            <span :class="{'red': scope.row.returnMoney && scope.row.returnMoney !=0}">{{scope.row.returnMoney == 0 ? 0 : ('-' + scope.row.returnMoney)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="paidInAmount" label="实收金额"></el-table-column>
        <el-table-column align="center" prop="amountReceivable" label="应收金额"></el-table-column>
        <el-table-column align="center" prop="giveChange" label="找零金额">
          <template slot-scope="scope">
            <span :class="{'red': scope.row.giveChange && scope.row.giveChange !=0}">{{scope.row.giveChange == 0 ? 0 : ('-' + scope.row.giveChange)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="cutSmallChanage" label="抹零金额">
          <template slot-scope="scope">
            <span :class="{'red': scope.row.cutSmallChanage && scope.row.cutSmallChanage !=0}">{{scope.row.cutSmallChanage == null || scope.row.cutSmallChanage == 0 ? 0 : ('-' + scope.row.cutSmallChanage)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="discount" label="打折消耗金额" width="105px">
          <template slot-scope="scope">
            <span :class="{'red': scope.row.discount && scope.row.discount !=0}">{{scope.row.discount == null || scope.row.discount == 0 ? 0 : ('-' + scope.row.discount)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="amountReceivable1" label="服务销售金额" width="105px"></el-table-column>
        <el-table-column align="center" prop="pickPrice" label="服务消耗金额" width="105px">
          <template slot-scope="scope">
            <span :class="{'red': scope.row.pickPrice && scope.row.pickPrice !=0}">{{(scope.row.pickPrice == null || scope.row.pickPrice == 0) ? 0 : ('-' + scope.row.pickPrice)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="returnAmount" label="服务退货金额" width="105px">
          <template slot-scope="scope">
            <span :class="{'red': scope.row.returnAmount && scope.row.returnAmount !=0}">{{scope.row.returnAmount == null || scope.row.returnAmount == 0 ? 0 : ('-' + scope.row.returnAmount)}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="redAcount">充值收支（现金流） 单位：元</div>
      <el-table :data="tableData3" :summary-method="getSummaries" show-summary class="myMemTable" :header-cell-style="{background:'#EFF1F5'}" style="width: 100%" max-height="340">
        <el-table-column align="center" prop="cashierName" label="收银员名称"></el-table-column>
        <el-table-column align="center" prop="cash" label="现金"></el-table-column>
        <el-table-column align="center" prop="bankCard" label="银行卡"></el-table-column>
        <el-table-column align="center" prop="aliPay" label="支付宝"></el-table-column>
        <el-table-column align="center" prop="wechatPay" label="微信"></el-table-column>
        <el-table-column align="center" prop="paidInAmount" label="实收金额"></el-table-column>
        <el-table-column align="center" prop="amountReceivable" label="应收金额"></el-table-column>
        <el-table-column align="center" prop="giveChange" label="找零金额">
          <template slot-scope="scope">
            <span :class="{'red': scope.row.giveChange && scope.row.giveChange !=0}">{{scope.row.giveChange == null || scope.row.giveChange == 0 ? 0 : ('-' + scope.row.giveChange)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="amountReceivable1" label="充值金额"></el-table-column>
        <el-table-column align="center" prop="rechargeAccountMoney" label="充值账户消耗">
          <template slot-scope="scope">
            <span :class="{'red': scope.row.rechargeAccountMoney && scope.row.rechargeAccountMoney !=0}">{{scope.row.rechargeAccountMoney == null || scope.row.rechargeAccountMoney == 0 ? 0 : ('-' + scope.row.rechargeAccountMoney)}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="returnAmount" label="充值账号退款支付金额" width="160px">
          <template slot-scope="scope">
            <span :class="{'red': scope.row.returnAmount && scope.row.returnAmount !=0}">{{scope.row.returnAmount == null || scope.row.returnAmount == 0 ? 0 : ('-' + scope.row.returnAmount)}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script type="text/javascript">
import { formatDate} from '@/components/common/js/date.js'
import {newsQueryStaf, newsQueryRecon, newsReconcilia, newsTionTopUp } from '@/api'
import infolist from '@/assets/js/info'
import vFilter from '@/assets/js/filter'
import Vue from 'vue'
for (let key in vFilter) {
  Vue.filter(key, vFilter[key])
}

export default {
  data () {
    return {
      staffSList: '',
      keyName: '',
      infolist: infolist,
      orderTime: [],
      tableData: [],
      fullscreenLoading: false,
      tableData2: [],
      tableData3: [],
      acountOn: ''
    }
  },
  created () {
    // if (this.$store.state.alivePage.flag) {
    //   this.orderTime = this.$store.state.alivePage.yearMonth
    //   this.keyName = this.$store.state.alivePage.staffId
    // }
    this.staffList()
    this.search()
    this.$store.commit('setAlivePage', 1)// 取消页码状态
  },
  computed: {
    computedStaff () {
      return (val, id, type) => {
        // type 1是姓名2岗位
        if (!val) {
          if (this.staffSList) {
            for (let i of this.staffSList) {
              if (i.staffId == id) {
                return type == 1 ? i.staffName : vFilter.filterPostId(i.postId, this.infolist.postIdData)
              }
            }
          }
        } else {
          return type == 1 ? val : vFilter.filterPostId(val, this.infolist.postIdData)
        }
      }
    }
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param; //columns-列
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0); 
          sums[index] = sums[index].toFixed(2);
          if(sums[index] != 0) {
            switch(column.property) {
              case "rechargeAccountMoney": sums[index]= '- ' + sums[index];
              break;
              case "returnAmount": sums[index]= '- ' + sums[index];
              break;
              case "giftAccountMoney": sums[index]= '- ' + sums[index];
              break;
              case "returnMoney": sums[index]= '- ' + sums[index];
              break;
              case "giveChange": sums[index]= '- ' + sums[index];
              break;
              case "cutSmallChanage": sums[index]= '- ' + sums[index];
              break;
              case "discount": sums[index]= '- ' + sums[index];
              break;
              case "pickPrice": sums[index]= '- ' + sums[index];
              break;
              default:
              break;
            }
          }
        } else {
          sums[index] = '--';
        }
      });
      return sums;
    },
    acountOne (val) {
      this.acountOn = val
      this.search()
    },
    tableRowClassName ({ row, column, rowIndex, columnIndex }) {
      // 把每一行的索引放进row
      if (rowIndex % 2 == 1) {
        return 'highLight'
      }
      return ''
    },
    specialCharacter () {
      this.keyName = this.keyName.replace(
        /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im,
        ''
      )
    },
    staffList () {
      newsQueryStaf({
        status: '1'
      }).then(res => {
        this.staffSList = res.data
      })
    },
    async search (val) {
      this.fullscreenLoading = true
      let res = await newsQueryRecon({
        startDate: this.orderTime ? this.orderTime[0] : null,
        endDate: this.orderTime ? this.orderTime[1] : null,
        cashierId: this.acountOn ? this.acountOn : null
      })
      let res2 = await newsReconcilia({
        startDate: this.orderTime ? this.orderTime[0] : null,
        endDate: this.orderTime ? this.orderTime[1] : null,
        cashierId: this.acountOn ? this.acountOn : null
      })
      let res3 = await newsTionTopUp({
        startDate: this.orderTime ? this.orderTime[0] : null,
        endDate: this.orderTime ? this.orderTime[1] : null,
        cashierId: this.acountOn ? this.acountOn : null
      })
      let resBox = res || res2 || res3
      this.fullscreenLoading = false
      if (resBox.code == 0) {
        this.$message({
          message: resBox.msg,
          type: 'error'
        })
      }
      this.tableData = res.data ? res.data : []
      this.tableData2 = res2.data ? res2.data : []
      this.tableData3 = res3.data ? res3.data : []
    },
    toView (row) {
      this.$store.commit('setRoyaltyData', {staffName: this.computedStaff(row.staffName, row.staffId, 1), storeFeeDTOS: row.storeFeeDTOS, type: 2})
      this.$router.push('/financeManageCenter/summaryDetail')
      this.$store.commit('setAlivePage', {yearMonth: this.orderTime, staffId: this.keyName, flag: true})
    },
    outportExcel () {
      if (!this.orderTime || this.orderTime == '') {
        this.$message({
          message: '请选择下单时间！',
          type: 'error'
        })
        return
      }
      let postData = {
        yearMonth: this.orderTime ? this.orderTime : null,
        staffId: this.keyName ? this.keyName : null
      }
      this.$http.post(exportSaleOrderList, postData, {
        headers: {
          userId: this.$store.state.userInfo.redisKey
        },
        responseType: 'blob'
      })
        .then(res => {
          if (res.data.type == 'application/json') {
            this.$message({
              message: '无提成费用汇总（团队）信息！',
              type: 'error'
            })
            return
          }
          const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
          const fileName = '提成费用汇总（团队）.xls'
          if ('msSaveOrOpenBlob' in navigator) {
            navigator.msSaveOrOpenBlob(blob, '提成费用汇总（团队）.xls')
            return
          }
          if ('download' in document.createElement('a')) {
            const elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
          } else {
            navigator.msSaveBlob(blob, fileName)
          }
        })
    }
  }
}
</script>
<style lang="less" scoped>
.orderMain {
  padding: 25px 0;
  .labelTit {
    color: #666;
    margin-right: 5px;
  }
  .infosearch {
    .el-input__inner {
      border-radius: 20px;
    }
    .searchBtn {
      width: 47px;
      height: 38px;
      background: #f83b56 url(../../assets/images/store/btn_datalist_search.png)
        no-repeat center;
    }
  }
  .myMemTable {
    margin-top: 25px;
    border: 1px solid #d5d9e3;
    .el-button--mini {
      padding: 8px;
      font-weight: bold;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
  }
  .defaults,
  .emptys {
    height: 600px;
    background: url(../../assets/images/store/img_vip_inquire.png) no-repeat
      center;
    text-align: center;
    font-size: 15px;
    color: #666;
    padding-top: 450px;
  }
  .emptys {
    background: url(../../assets/images/store/img_vip_none.png) no-repeat center;
  }
  .redAcount{font-size: 16px;font-weight: bold;margin-top:2%;}
}
</style>
<style lang="less">
.orderMain {
  .el-date-editor .el-range-separator {
    width: 26px;
  }
}
.myMemTable {
  .operation {
    .cell {
      padding: 0;
    }
  }
  .el-table__header {
    background: rgb(239, 241, 245);
  }
  .highLight {
    background: #eff1f5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/accountStatiste.vue